import type { InputStatusState } from '../internal';

/** Screen-reader status text for the sr-only live region. */
export function computeSrText(state: InputStatusState, errorMessage?: string): string {
  switch (state) {
    case 'loading':
      return 'Saving…';
    case 'success':
      return 'Saved';
    case 'error':
      return errorMessage ? `Error: ${errorMessage}` : 'Error';
    default:
      return '';
  }
}

/** ARIA attributes to spread on the interactive control element. */
export function computeAriaBindings(state: InputStatusState): {
  'aria-invalid'?: 'true';
  'aria-busy'?: 'true';
} {
  if (state === 'error') return { 'aria-invalid': 'true' };
  if (state === 'loading') return { 'aria-busy': 'true' };
  return {};
}
